import {
  HEX,
  SCALING,
  Targeting
} from "../../../src";
const nature_mend = {
  slug: "nature_mend",
  name: "Nature Mend",
  abilityIcon: "nature_mend",
  description: "Channels natural energy to heal a nearby ally",
  costs: [{ stat: "mana", value: 8 }],
  targeting: Targeting.SingleAlly,
  cooldown: 0,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "gain",
              scalingFactors: SCALING.NATURE_HEALING
            }
          ]
        }
      }
    ]
  },
  tags: ["spell", "ranged", "heal", "green"]
};
export {
  nature_mend
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vbGliL2FiaWxpdGllcy9kcnVpZC9uYXR1cmUtbWVuZC50cyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiaW1wb3J0IHtcbiAgQWN0aW9uRGVmaW5pdGlvbixcbiAgSEVYLFxuICBTQ0FMSU5HLFxuICBUYXJnZXRpbmcsXG59IGZyb20gJy4uLy4uLy4uL3NyYyc7XG5cbmV4cG9ydCBjb25zdCBuYXR1cmVfbWVuZDogQWN0aW9uRGVmaW5pdGlvbiA9IHtcbiAgc2x1ZzogJ25hdHVyZV9tZW5kJyxcbiAgbmFtZTogJ05hdHVyZSBNZW5kJyxcbiAgYWJpbGl0eUljb246ICduYXR1cmVfbWVuZCcsXG4gIGRlc2NyaXB0aW9uOlxuICAgICdDaGFubmVscyBuYXR1cmFsIGVuZXJneSB0byBoZWFsIGEgbmVhcmJ5IGFsbHknLFxuICBjb3N0czogW3sgc3RhdDogJ21hbmEnLCB2YWx1ZTogOCB9XSxcbiAgdGFyZ2V0aW5nOiBUYXJnZXRpbmcuU2luZ2xlQWxseSxcbiAgY29vbGRvd246IDAsXG4gIGltcGFjdFNjaGVkdWxlOiB7XG4gICAgWzBdOiBbXG4gICAgICB7XG4gICAgICAgIGhleGVzOiBIRVguRE9ULFxuICAgICAgICBlZmZlY3Q6IHtcbiAgICAgICAgICBzdGF0Q2hhbmdlczogW1xuICAgICAgICAgICAge1xuICAgICAgICAgICAgICBzdGF0OiAnaGVhbHRoJyxcbiAgICAgICAgICAgICAgZGlyZWN0aW9uOiAnZ2FpbicsXG4gICAgICAgICAgICAgIHNjYWxpbmdGYWN0b3JzOiBTQ0FMSU5HLk5BVFVSRV9IRUFMSU5HLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICBdLFxuICAgICAgICB9LFxuICAgICAgfSxcbiAgICBdLFxuICB9LFxuICB0YWdzOiBbJ3NwZWxsJywgJ3JhbmdlZCcsICdoZWFsJywgJ2dyZWVuJ10sXG59O1xuIl0sCiAgIm1hcHBpbmdzIjogIkFBQUE7QUFBQSxFQUVFO0FBQUEsRUFDQTtBQUFBLEVBQ0E7QUFBQSxPQUNLO0FBRUEsTUFBTSxjQUFnQztBQUFBLEVBQzNDLE1BQU07QUFBQSxFQUNOLE1BQU07QUFBQSxFQUNOLGFBQWE7QUFBQSxFQUNiLGFBQ0U7QUFBQSxFQUNGLE9BQU8sQ0FBQyxFQUFFLE1BQU0sUUFBUSxPQUFPLEVBQUUsQ0FBQztBQUFBLEVBQ2xDLFdBQVcsVUFBVTtBQUFBLEVBQ3JCLFVBQVU7QUFBQSxFQUNWLGdCQUFnQjtBQUFBLElBQ2QsQ0FBQyxDQUFDLEdBQUc7QUFBQSxNQUNIO0FBQUEsUUFDRSxPQUFPLElBQUk7QUFBQSxRQUNYLFFBQVE7QUFBQSxVQUNOLGFBQWE7QUFBQSxZQUNYO0FBQUEsY0FDRSxNQUFNO0FBQUEsY0FDTixXQUFXO0FBQUEsY0FDWCxnQkFBZ0IsUUFBUTtBQUFBLFlBQzFCO0FBQUEsVUFDRjtBQUFBLFFBQ0Y7QUFBQSxNQUNGO0FBQUEsSUFDRjtBQUFBLEVBQ0Y7QUFBQSxFQUNBLE1BQU0sQ0FBQyxTQUFTLFVBQVUsUUFBUSxPQUFPO0FBQzNDOyIsCiAgIm5hbWVzIjogW10KfQo=
